<template>
    <section class="AddInfos" aria-labelledby="addinfos-title" v-if="displayItems.length">
      <div class="AddInfos__container">
        <h2 id="addinfos-title" class="AddInfos__title raleway-bold-p16">INFORMATIONS COMPLÉMENTAIRES</h2>
  
        <div class="AddInfos__grid">
          <article
            v-for="(it, i) in displayItems"
            :key="it.id || i"
            class="AddInfos__card"
          >
            <div class="AddInfos__icon" v-html="icons[it.kind] || icons.default" />
            <div class="AddInfos__k raleway-semi-p15">{{ kFor(it.kind) }}</div>
            <p class="AddInfos__v raleway-reg-p15">{{ it.description || it.label }}</p>
          </article>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'AdditionalInfosSection',
    props: {
      items: { type: Array, default: () => [] },
      limit: { type: Number, default: 6 }
    },
    computed: {
      displayItems () {
        const pruned = (this.items || [])
          .filter(Boolean)
          .map(i => ({
            id: i.id,
            kind: (i.kind || '').toLowerCase(),
            label: i.label || '',
            description: i.description || i.label || ''
          }))
        return this.limit > 0 ? pruned.slice(0, this.limit) : pruned
      },
      icons () {
        const stroke = '#2d5f49'
        const w = 72, h = 72, sw = 2
  
        return {
          audio: `
            <svg viewBox="0 0 48 48" width="${w}" height="${h}" fill="none" stroke="${stroke}" stroke-width="${sw}">
              <rect x="14" y="8" width="20" height="32" rx="3"/>
              <circle cx="24" cy="18" r="4"/><circle cx="24" cy="30" r="4"/>
            </svg>
          `,
          wifi: `
            <svg viewBox="0 0 48 48" width="${w}" height="${h}" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round">
              <path d="M8 18c8-8 24-8 32 0"/>
              <path d="M14 24c5-5 15-5 20 0"/>
              <path d="M20 30c3-3 5-3 8 0"/>
              <circle cx="24" cy="36" r="2" fill="${stroke}" stroke="none"/>
            </svg>
          `,
          projection: `
            <svg viewBox="0 0 48 48" width="${w}" height="${h}" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round">
              <rect x="6" y="10" width="36" height="22" rx="3"/>
              <path d="M10 36h28"/>
              <circle cx="18" cy="21" r="3"/>
              <circle cx="26" cy="21" r="3"/>
              <circle cx="34" cy="21" r="3"/>
            </svg>
          `,
          projecteur: `
            <svg viewBox="0 0 48 48" width="${w}" height="${h}" fill="none" stroke="${stroke}" stroke-width="${sw}">
              <rect x="8" y="14" width="32" height="18" rx="3"/><path d="M12 36h24"/>
            </svg>
          `,
          screen: `
            <svg viewBox="0 0 48 48" width="${w}" height="${h}" fill="none" stroke="${stroke}" stroke-width="${sw}">
              <rect x="6" y="10" width="36" height="22" rx="2"/><path d="M10 36h28"/>
            </svg>
          `,
          default: `
            <svg viewBox="0 0 48 48" width="${w}" height="${h}" fill="none" stroke="${stroke}" stroke-width="${sw}">
              <circle cx="24" cy="24" r="12"/>
            </svg>
          `
        }
      }
    },
    methods: {
      kFor (kind) {
        const map = {
          audio: 'AUDIO',
          wifi: 'WIFI',
          projection: 'PROJECTION',
          projecteur: 'PROJECTION',
          screen: 'ÉCRAN'
        }
        return map[(kind || '').toLowerCase()] || (kind || '').toUpperCase()
      }
    }
  }
  </script>
  
  <style>
  .AddInfos {
    padding: clamp(18px, 3.8vw, 40px) 16px;
    background: #f5f8f6; 
  }
  .AddInfos__container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .AddInfos__title {
    text-align: center;
    letter-spacing: .6px;
    margin: 0 0 clamp(16px, 3vw, 28px);
    color: #0e0e0e;
    margin: 0 0 clamp(10px, 1.8vw, 14px);
  }
  .AddInfos__grid {
    display: grid;
    gap: clamp(18px, 2.4vw, 28px);
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 980px) {
    .AddInfos__grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 560px) {
    .AddInfos__grid { grid-template-columns: 1fr; }
  }
  .AddInfos__card {
    background: #fff;
    border-radius: 14px;
    padding: clamp(16px, 2.4vw, 26px);
    text-align: center;
    box-shadow: 0 1px 0 rgba(0,0,0,.04);
    display: grid;
    justify-items: center;
    gap: 10px;
  }
  .AddInfos__icon {
    width: 72px;
    height: 72px;
    display: grid;
    place-items: center;
  }
  .AddInfos__k {
    color: #2d5f49;
    letter-spacing: .3px;
  }
  .AddInfos__v {
    color: #0f0f0f;
    line-height: 1.8;
    max-width: 36ch;
    margin: 0;
  }
  </style>  